import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Pipe({
    name: 'auth',
    pure: false
})
export class AuthPipe implements PipeTransform {

  constructor(private authService: AuthService) { }

  transform(value: string): unknown {
    let user = this.authService.getUser();
    return user.recordSeries.indexOf(value) > -1;
  }

}
